// extracted by mini-css-extract-plugin
export default {"price":"Exchange_price__wgLTv","pTable":"Exchange_pTable__nVLJj"};